<template>
  <div id="missingExpenses">
    <v-layout>
      <page-title :heading="heading" :subheading="subheading" :icon="icon" class="mr-5"></page-title>
      <h2 class="ml-5 mt-4 subtitle-1">
        {{ $t('conciliation.period') }}: {{ dateFormat(start_date) }} - {{ dateFormat(end_date) }}
      </h2>
    </v-layout>
    <v-container class="py-0 my-0">
      <v-flex class="text-xs-right py-0 my-0">
        <v-btn v-if="selected.length > 0" @click="showDialogSelectExpenses" color="primary" round outline>
          {{ $t('expenses.selectExpense') }}
        </v-btn>
        <v-dialog persistent v-model="dialog" max-width="700px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" round outline v-on="on">
              <v-icon left>filter_list</v-icon>
              {{ $t('general.filter') }}
            </v-btn>
          </template>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">
                {{ $t('general.filter') }}
              </h2>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-form lazy-validation ref="form" v-model="valid">
                  <v-layout>
                    <v-flex xs6>
                      <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            required
                            :rules="rules.required"
                            :error-messages="errors.startDate"
                            v-model="start_date"
                            :label="$t('general.startDate')"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :max="end_date"
                          color="primary"
                          v-model="start_date"
                          @input="menu = false"
                          :locale="$t('history.local')"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs6>
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            required
                            :rules="rules.required"
                            v-model="end_date"
                            :error-messages="errors.endDate"
                            :label="$t('general.endDate')"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          v-model="end_date"
                          @input="menu2 = false"
                          :max="new Date().toISOString().substr(0, 10)"
                          :min="start_date"
                          :locale="$t('history.local')"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    v-if="
                      userLogged.roles && userLogged.roles[0].name === 'ADMIN'
                    "
                  >
                    <v-flex>
                      <v-switch
                        color="primary"
                        v-model="switchAllEmployees"
                        :label="
                          switchAllEmployees
                            ? $t('expenseDetailEmployee.allEmployees')
                            : $t('expenseDetailEmployee.perEmployee')
                        "
                      ></v-switch>
                      <v-autocomplete
                        v-if="!switchAllEmployees"
                        v-model="selectedEmployee"
                        item-text="name"
                        item-value="id"
                        persistent-hint
                        :rules="rules.required"
                        :items="employees"
                        :label="$t('expenseDetailEmployee.employee')"
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" round flat @click="close">
                {{ $t('general.close') }}
              </v-btn>
              <v-btn
                :loading="loading"
                :disabled="loading"
                color="primary"
                round
                depressed
                @click="send"
              >
                {{ $t('general.submit') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <b-row>
        <!-- Monto TC -->
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content yellow-block">
            <div class="">
              <div>
                <div class="widget-heading text-center">
                  {{ $t('conciliation.tCAmount') }}:
                </div>
                <div class="text-center" v-if="loading">
                  <v-progress-circular
                    indeterminate
                    size="20"
                  ></v-progress-circular>
                </div>
                <div class="widget-data-filter " v-else>
                  <h2><b>{{ allAmount | formatCurrency }}</b></h2>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <!-- Monto conciliado Bluespend -->
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content green-block">
            <div class="">
              <div>
                <div class="widget-heading text-center">
                  {{ $t('conciliation.bluespendReconciledAmount') }}:
                </div>
                <div class="text-center" v-if="loading">
                  <v-progress-circular
                    indeterminate
                    size="20"
                  ></v-progress-circular>
                </div>
                <div class="widget-data-filter " v-else>
                  <h2><b>{{ consiliateAmount | formatCurrency }}</b></h2>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <!-- Monto Faltante -->
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content red-block">
            <div class="">
              <div>
                <div class="widget-heading text-center">
                  {{ $t('conciliation.missingAmount') }}:
                </div>
                <div class="text-center" v-if="loading">
                  <v-progress-circular
                    indeterminate
                    size="20"
                  ></v-progress-circular>
                </div>
                <div class="widget-data-filter " v-else>
                  <h2><b>{{ missingAmount | formatCurrency }}</b></h2>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <!-- Monto Excluidos -->
        <b-col class="px-2" col-md-6 col-xl-4>
          <b-card class="pa-0 widget-content blue-block">
            <div class="">
              <div>
                <div class="widget-heading text-center">
                  {{ $t('conciliation.excludedAmount') }}:
                </div>
                <div class="text-center" v-if="loading">
                  <v-progress-circular
                    indeterminate
                    size="20"
                  ></v-progress-circular>
                </div>
                <div class="widget-data-filter " v-else>
                  <h2><b>{{ excludedAmount | formatCurrency }}</b></h2>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <!-- Filtro Empleados -->
        <b-col
          class="px-2"
          col-md-12
          col-xl-12
          v-if="
            userLogged.roles &&
            userLogged.roles[0].name === 'ADMIN' &&
            selectedEmployee
          "
        >
          <b-card class="ma-0 pa-0 widget-content bg-info">
            <div class="text-white ma-0 pa-0">
              <div class="ma-0 pa-0">
                <div class="text-white text-center" v-if="!selectedEmployee">
                  <v-progress-circular
                    indeterminate
                    size="20"
                  ></v-progress-circular>
                </div>
                <div class="text-white ma-0 pa-0" v-else>
                  <v-autocomplete
                    v-model="selectedEmployee"
                    item-text="name"
                    item-value="id"
                    :rules="rules.required"
                    :items="employees"
                    class="select-employee"
                    @change="selectedEmployeeChange()"
                  >
                    <template #selection="{ item }">
                      <span class="select-employee text-white text-truncate">{{
                        item.name
                      }}</span>
                    </template>
                  </v-autocomplete>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <v-spacer class="my-3"></v-spacer>
      <template variant="primary" v-slot:title>
        <h5 class="my-0">{{ $t('conciliation.status.missing') }}</h5>
      </template>
      <v-flex>
<!-- AQUI -->
        <b-tabs v-model="selectedTab" pills active-nav-item-class="primary">
          <b-tab v-for="(item, i) in tabsStatus" :key="i" >
            <template variant="primary"  v-slot:title>
              <h5 class="my-0">{{item.text}}</h5>
            </template>
          </b-tab>
        </b-tabs>

        <v-toolbar flat color="bg-sidebar" dark>
          <h2 class="my-0">{{ $t('conciliation.status.missing') }}</h2>
          <v-spacer></v-spacer>
          <v-text-field
            color="light"
            v-model="search"
            :label="$t('general.search')"
            clearable
            append-outer-icon="search"
          >
          </v-text-field>
        </v-toolbar>
        <v-data-table
          :search="search"
          class="elevation-2"
          :headers="headers"
          :items="excludedExpenses"
          :loading="loadTable"
          :rows-per-page-items="[10, 15, 25]"
          :pagination.sync="pagination"
        >
          <template v-slot:headers="props">
            <tr class="bg-heavy-rain">
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column',
                  header.sortable ? 'sortable' : '',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : '',
                ]"
                @click="changeSort(header)"
              >
                <h2 class="font-weight-black primary--text mb-0">
                  <v-icon small class="primary--text" v-if="header.sortable"
                    >arrow_upward</v-icon
                  >
                  {{ header.text }}
                </h2>
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr class="">
              <td class="text-sm-center" width="20px">
                <div style="display: flex; align-items: center;">
                  <v-checkbox
                    v-if="props.item.amex_expense.expense_item_back.length > 0 && validateAmount(props.item) && userLogged && userLogged.id === props.item.amex_expense.user_id"
                    :input-value="selected.includes(props.item)"
                    @change="toggleSelection(props.item)"
                    color="primary" hide-details>
                  </v-checkbox>
                  <span>{{ props.item.amex_expense.id }}</span>
                </div>
              </td>
              <td class="text-sm-center" width="150px">
                {{ props.item.amex_expense.date }}
              </td>
              <td class="text-sm-center">
                {{ props.item.amex_expense.transaction_number }}
              </td>
              <td class="text-sm-center">
                {{ props.item.amex_expense.description }}
              </td>
              <td class="text-sm-center">
                {{ props.item.amex_expense.user.name }}
              </td>
              <td class="text-sm-center">
                {{ props.item.amex_expense.supplier_name }}
              </td>
              <td class="text-sm-center">
                {{ props.item.amex_expense.amount | formatCurrency }}
              </td>
              <td v-if="userLogged && userLogged.id === props.item.amex_expense.user_id" class="text-sm-center">
                <v-tooltip v-if="props.item.amex_expense.charged_expenses_items === null" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn @click="addExpense(props.item)" small outline icon color="info" v-on="on">
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('expenseItems.add') }}</span>
                </v-tooltip>
                <v-tooltip v-if="props.item.amex_expense.expense_item_back !== null && props.item.amex_expense.expense_item_back.length > 0 && viewAddMoreXml(props.item)" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn @click="addExpense(props.item)" small outline icon color="warning" v-on="on">
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('workflowValidation.addPendingExpenses') }}</span>
                </v-tooltip>
                <v-tooltip v-if="props.item.amex_expense.charged_expenses_items !== null" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn small outline icon color="#73D673" v-on="on">
                      <v-icon small>mdi-check-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('expenses.expenseCharged') }}</span>
                </v-tooltip>
              </td>
              <td v-else></td>
            </tr>
          </template>
        </v-data-table>
<!-- AQUI -->
      </v-flex>
    </v-container>
    <v-dialog persistent v-model="addExpenseDialog" max-width="700px">
      <v-card>
        <v-toolbar flat>
          <h2 class="font-weight-black primary--text mb-0">
            {{ $t('expenseItems.add') }}
          </h2>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-switch
              color="primary"
              v-model="switchExpenseType"
              :label="
                switchExpenseType
                  ? $t('expenseItems.fiscal')
                  : $t('expenseItems.manual')
              "
            ></v-switch>
            <!-- Fiscal -->
            <v-form ref="formXML" v-if="switchExpenseType" lazy-validation>
              <v-container v-if="selectXml">
                <v-layout>
                  <v-flex xs-12>
                    <vue-dropzone
                      ref="dropzoneXML"
                      id="dropzoneXML"
                      :options="dropzoneOptionsXML"
                      v-on:vdropzone-added="fileAddedXml"
                      v-on:vdropzone-error="fileUploadError"
                      v-on:vdropzone-success="xmlUpload"
                      v-on:vdropzone-queue-complete="xmlQueueComplete"
                    >
                    </vue-dropzone>
                    <v-progress-linear
                      v-if="loadingFile"
                      :indeterminate="loadingFile"
                    ></v-progress-linear>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-container v-if="uploadedXML && uploadIndex > -1 && !readXml">
                <v-layout row wrap>
                  <p>
                    {{
                      $t('expenseItems.readItemProgress', {
                        current: uploadIndex + 1,
                        total: uploadedXML.length,
                      })
                    }}
                  </p>
                </v-layout>
              </v-container>
              <v-container v-if="readXml">
                <v-layout row wrap>
                  <!-- ADVERTENCIAS -->
                  <v-container class="py-0 my-0" v-if="errorAmount">
                    <b-row>
                      <b-col class="px-2" col-md-12 col-xl-12>
                        <b-card class="pa-0 widget-content bg-danger">
                          <div class="text-white">
                            <div>
                              <div class="widget-heading text-center">
                                {{ $t('expenses.errorAmount') }}
                              </div>
                            </div>
                          </div>
                        </b-card>
                      </b-col>
                    </b-row>
                  </v-container>
                  <v-flex class="d-flex" xs12>
                    <v-text-field
                      style="width: 80%"
                      v-model="editedItemExpense.emisor"
                      :label="'Emisor'"
                      :error-messages="errors.uuid"
                      readonly
                    />
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon color="primary" v-on="on">verified</v-icon>
                      </template>
                      <span>{{ $t('expenseItems.verifyEFOMsg') }}</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItemExpense.uuid"
                      :label="$t('general.uuid')"
                      :error-messages="errors.uuid"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItemExpense.date"
                      :label="$t('general.date')"
                      :error-messages="errors.date"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete
                      v-model="editedItemExpense.gst_categories_id"
                      :label="$t('general.category')"
                      :items="categories"
                      item-text="name"
                      item-value="id"
                      :error-messages="errors.gst_categories_id"
                      :rules="rules.required"
                    >
                      <template slot="selection" slot-scope="data">
                        {{ data.item.name }}
                      </template>
                      <template slot="item" slot-scope="data">
                        {{ data.item.name }}
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItemExpense.country.descripcion"
                      :error-messages="errors.country"
                      :label="$t('general.country')"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      v-model="editedItemExpense.description"
                      :error-messages="errors.description"
                      :label="$t('general.description')"
                      readonly
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItemExpense.currency.descripcion"
                      :error-messages="errors.currency"
                      :label="$t('general.currency')"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItemExpense.exchange"
                      :label="$t('general.exchangeRate')"
                      :error-messages="errors.exchange"
                      :rules="rules.required && rules.decimal && rules.exchange"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItemExpense.subtotal"
                      :label="$t('general.subtotal')"
                      :error-messages="errors.subtotal"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      v-model="editedItemExpense.discount"
                      :label="$t('general.discount')"
                      :error-messages="errors.discount"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      v-model="editedItemExpense.total"
                      :label="$t('general.total')"
                      :error-messages="errors.total"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItemExpense.sat_forma_pago.descripcion"
                      :label="$t('general.formaPago')"
                      :error-messages="errors.sat_formaPago_id"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItemExpense.sat_metodo_pago.descripcion"
                      :label="$t('general.metodoPago')"
                      :error-messages="errors.sat_metodoPago_id"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field v-model="editedItemExpense.folio" :error-messages="errors.folio" :label="$t('general.folioRef')" readonly></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      v-model="editedItemExpense.comment"
                      :label="$t('general.comment')"
                      :error-messages="errors.comment"
                    ></v-textarea>
                  </v-flex>
                  <!-- PROPINA -->
                  <v-flex xs12 md6>
                    <v-text-field v-model="editedItemExpense.tip_amount" @input="validateTipAmount" :error-messages="errors.amount" :label="$t('expenses.addTip')"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <vue-dropzone
                      ref="dropzone"
                      id="dropzone"
                      :options="dropzoneOptions"
                      v-on:vdropzone-file-added="fileAdded"
                      v-on:vdropzone-error="fileUploadError"
                      v-on:vdropzone-success="fileUploadTip">
                    </vue-dropzone>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
            <!-- Fin Fiscal -->
            <!-- No Fiscal -->
            <v-layout wrap v-if="!switchExpenseType">
              <v-alert
                :value="error"
                color="error"
                icon="warning"
                outline
                transition="scale-transition"
              >
                {{ errorMessage }}
              </v-alert>
              <v-form ref="form" lazy-validation>
                <v-container>
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <v-menu
                        v-model="datemenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="editedItemExpense.date"
                            :label="$t('general.date')"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            :rules="rules.required"
                            :error-messages="errors.date"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          :locale="$t('general.locale')"
                          v-model="editedItemExpense.date"
                          @input="datemenu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-autocomplete
                        v-model="editedItemExpense.gst_categories_id"
                        :label="$t('general.category')"
                        :items="categories"
                        item-text="name"
                        item-value="id"
                        :error-messages="errors.gst_categories_id"
                        :rules="rules.required"
                      >
                        <template slot="selection" slot-scope="data">
                          {{ data.item.name }}
                        </template>
                        <template slot="item" slot-scope="data">
                          {{ data.item.name }}
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-autocomplete
                        v-model="editedItemExpense.country.id"
                        :error-messages="errors.country"
                        :label="$t('general.country')"
                        :items="items"
                        item-value="id"
                        item-text="descripcion"
                        :rules="rules.required"
                        :search-input.sync="search"
                        :filter="dataArrayFilter.filter"
                        cache-items
                        flat
                        hide-details
                        auto-select-first
                        clearable
                      >
                        <template slot="selection" slot-scope="data">
                          {{ data.item.c_Pais }} - {{ data.item.descripcion }}
                        </template>
                        <template slot="item" slot-scope="data">
                          {{ data.item.c_Pais }} - {{ data.item.descripcion }}
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editedItemExpense.description"
                        :label="$t('general.description')"
                        :error-messages="errors.description"
                        :rules="rules.required"
                      >
                      </v-textarea>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-autocomplete
                        clearable
                        v-model="editedItemExpense.currency"
                        :label="$t('general.currency')"
                        :error-messages="errors.currency"
                        :items="satMoneda"
                        item-text="descripcion"
                        item-value="id"
                        :filter="currencyFilter"
                        :rules="rules.required"
                        return-object
                      >
                        <template slot="selection" slot-scope="data">
                          {{ data.item.c_Moneda }} - {{ data.item.descripcion }}
                        </template>
                        <template slot="item" slot-scope="data">
                          {{ data.item.c_Moneda }} - {{ data.item.descripcion }}
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        :readonly="setMXN"
                        v-model="editedItemExpense.exchange"
                        :label="$t('general.exchangeRate')"
                        :error-messages="errors.exchange"
                        :rules="
                          rules.required && rules.decimal && rules.exchange
                        "
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 md5>
                      <v-text-field
                        v-model="editedItemExpense.subtotal"
                        :label="$t('general.subtotal')"
                        :error-messages="errors.subtotal"
                        :rules="rules.required && rules.decimal"
                        @keyup="getTotal(1)"
                      >
                        <v-tooltip slot="append" bottom>
                          <v-icon slot="activator" color="grey" dark
                            >mdi-help-circle</v-icon
                          >
                          <span>{{ $t('expenses.amountMessage') }}</span>
                        </v-tooltip>
                      </v-text-field>
                      <p class="caption">
                        {{
                          amountMXN(
                            editedItemExpense.subtotal,
                            editedItemExpense.exchange
                          ) > 0.0
                            ? '$' +
                              amountMXN(
                                editedItemExpense.subtotal,
                                editedItemExpense.exchange
                              ) +
                              ' MXN'
                            : ''
                        }}
                      </p>
                    </v-flex>
                    <v-flex xs1 md2></v-flex>
                    <v-flex xs12 md5>
                      <v-text-field
                        v-model="editedItemExpense.total"
                        :label="$t('general.total')"
                        :error-messages="errors.total"
                        :rules="rules.required && rules.decimal"
                        @keyup="getTotal(2)"
                      >
                        <v-tooltip slot="append" bottom>
                          <v-icon slot="activator" color="grey" dark
                            >mdi-help-circle</v-icon
                          >
                          <span>{{ $t('expenses.amountMessage') }}</span>
                        </v-tooltip>
                      </v-text-field>
                      <p class="caption">
                        {{
                          amountMXN(
                            editedItemExpense.total,
                            editedItemExpense.exchange
                          ) > 0.0
                            ? '$' +
                              amountMXN(
                                editedItemExpense.total,
                                editedItemExpense.exchange
                              ) +
                              ' MXN'
                            : ''
                        }}
                      </p>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-autocomplete
                        v-model="editedItemExpense.sat_forma_pago"
                        :label="$t('general.formaPago')"
                        :items="satFormaPago"
                        item-text="descripcion"
                        item-value="id"
                        :rules="rules.required"
                        :error-messages="errors.sat_formaPago_id"
                        return-object
                      >
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItemExpense.folio"
                        :error-messages="errors.folio"
                        :label="
                          $t('general.folioRef') + $t('general.optionalField')
                        "
                      >
                      </v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 v-if="editedIndex > -1">
                        <label>{{$t('general.image')}}:</label>
                        <v-btn v-if="!isPDF(dataURL)" depressed color="primary" block @click="viewImg = !viewImg">
                          <v-icon left>{{viewImg === false ? 'visibility' : 'visibility_off'}}</v-icon>
                            {{ viewImg === false ? $t('workflowValidation.showImage') : $t('workflowValidation.hideImage')}}
                        </v-btn>
                        <v-btn block v-if="isPDF(dataURL)" @click="openPDF()" color="primary" depressed>
                          <v-icon left>insert_drive_file</v-icon> {{$t('expenseItems.watchFile')}}
                        </v-btn>
                        <div v-if="viewImg === true">
                          <a v-if="!isPDF(dataURL)" @click="openPDF()">
                            <zoom-on-hover :img-normal="dataURL"></zoom-on-hover>
                          </a>
                        </div>
                        <label>{{$t('workflowValidation.changeImage')}}</label>
                        <vue-dropzone
                          ref="dropzone"
                          id="dropzone"
                          :options="dropzoneOptions"
                          v-on:vdropzone-file-added="fileAdded"
                          v-on:vdropzone-error="fileUploadError"
                          v-on:vdropzone-success="fileUpload">
                        </vue-dropzone>
                      </v-flex> -->
                    <!-- <v-flex xs12>
                        <v-textarea
                          v-model="editedItemExpense.comment"
                          :label="$t('general.comment') + $t('general.optionalField')"
                          :error-messages="errors.comment">
                        </v-textarea>
                      </v-flex> -->
                    <v-flex xs12>
                      <vue-dropzone
                        ref="dropzone"
                        id="dropzone"
                        :options="dropzoneOptions"
                        v-on:vdropzone-file-added="fileAdded"
                        v-on:vdropzone-error="fileUploadError"
                        v-on:vdropzone-success="fileUpload"
                      >
                      </vue-dropzone>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-layout>
            <!-- Fin No Fiscal -->
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="switchExpenseType ? closeDialogXML() : closeDialog()" color="primary darken-1" round flat>
            {{ $t('general.close') }}
          </v-btn>
          <v-btn v-if="switchExpenseType" @click="resetXML()" round color="warning" flat>
            {{ $t('general.reset') }}
          </v-btn>
          <v-btn v-if="readXml && !nextXml " @click="submitXML()" round color="primary" :loading="loading" :disabled="loading || errorAmount">
            {{ submitXMLButton }}
          </v-btn>
          <v-btn v-if="nextXml" @click="showNextUpload()" round color="success" :loading="loading" :disabled="loading || errorAmount">
            {{ $t('general.NextXml') }}
          </v-btn>
          <v-btn v-if="!switchExpenseType" :loading="loading" :disabled="loading" color="primary" round depressed @click="submitReceiptsValidate()">
            {{ $t('general.submit') }}
          </v-btn>
            <!-- @click="switchExpenseType ? submitXML() : submit()" -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="confirmDiffAmountsDialog" max-width="500px">
      <v-card>
        <v-toolbar flat>
          <h2 class="font-weight-black primary--text mb-0">{{ $t('conciliation.confirmAMountExpenseCharged') }}</h2>
        </v-toolbar>
        <v-card-text class="text-sm-justify">
          <span>{{$t('conciliation.questionCpmfirmCharge', {amountItem: amountItemDialog})}},</span>
          <span>{{$t('conciliation.sinceAmexAmount', {amountAmex: amountAmexDialog})}}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            round
            flat
            @click="switchExpenseType ? closeDialogXML() : closeDialog()">
            {{ $t('general.cancel') }}
          </v-btn>
          <v-btn
            :loading="loading"
            :disabled="loading"
            color="primary"
            round
            depressed
            @click="switchExpenseType ? submitXML() : submit()">
            {{ $t('general.submit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSelectExpenses" max-width="900px" scrollable persistent>
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.relateExpense') }}
            </h2>
          </v-toolbar>
          <v-card-text>
            <v-layout class="my-3">
              <v-flex xs8>
                <h3 class="font-weight-black primary--text">
                  {{ $t('expenses.selectExpense') }}
                </h3>
              </v-flex>
              <v-flex xs4>
                <v-btn @click="showDialogExpenses()" color="primary" class="pr-2" round outline>
                  <v-icon left>attach_money</v-icon>
                  {{ $t('expenses.add') }}
                </v-btn>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers2"
              :items="expensesOpen"
              no-data-text="No hay datos que mostrar"
              hide-default-footer
              disable-pagination
              hide-actions
              :pagination.sync="paginationExpenses"
              :footer-props="{ 'items-per-page-options': [-1] }"
              class="elevation-1">
              <template v-slot:items="props">
                <tr @click="selectRow(props.item)" class="rowExpense" :class="{ selectedRow: props.item.isSelected }" :key="props.index">
                  <td class="text-sm-center">{{ props.item.id }}</td>
                  <td class="text-sm-center">{{ props.item.description }}</td>
                  <td class="text-sm-center">{{ props.item.start_date }} - {{ props.item.end_date }}</td>
                  <td class="text-sm-center">{{ props.item.project.name }}</td>
                  <td class="text-sm-center">{{ props.item.advance }}</td>
                  <td class="text-sm-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn @click="editItem(props.item)" small outline icon color="info" v-on="on">
                          <v-icon small>edit</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('general.edit') }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="closeDialogSelectExpenses" round flat color="primary darken-1">
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn v-if="expense !== null" @click="restoreExpense()" round color="primary" :loading="loadingSelectExpenses" :disabled="loadingSelectExpenses">
              {{ $t('general.accept') }}
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExpenses" max-width="600px" persistent>
      <v-card>
        <v-toolbar flat>
          <h2 class="font-weight-black primary--text mb-0">
            {{ formTitle }}
          </h2>
        </v-toolbar>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="valid">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-menu
                    v-model="startDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        clearable
                        required
                        :rules="rules.required"
                        v-model="editedItem.start_date"
                        :label="$t('general.startDate')"
                        prepend-icon="event"
                        readonly
                        v-on="on">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      :locale="$t('general.locale')"
                      v-model="editedItem.start_date"
                      @input="start = false">
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-menu
                    v-model="endDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        clearable
                        required
                        :rules="rules.required"
                        v-model="editedItem.end_date"
                        :label="$t('general.endDate')"
                        prepend-icon="event"
                        readonly
                        v-on="on">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      :locale="$t('general.locale')"
                      v-model="editedItem.end_date"
                      @input="end = false">
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-select
                    v-model="editedItem.project_id"
                    :label="$t('general.project')"
                    :items="projectsFilter"
                    item-value="id"
                    item-text="name"
                    :rules="rules.required">
                  </v-select>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    clearable
                    required
                    :rules="rules.required"
                    :label="$t('general.description')"
                    v-model="editedItem.description">
                  </v-text-field>
                </v-flex>
                <v-flex xs6 sm6 md6>
                  <v-radio-group v-model="type" row>
                    <v-radio v-if="pettyCashAmount" :disabled="isDisabledPettyCash" :label="$t('pettyCash.title')" value="pettyCash"></v-radio>
                    <v-radio v-if="amexCardAmount" :disabled="isDisabledAmexCard" :label="$t('amexCard.title')" value="amexCard"></v-radio>
                    <v-radio :disabled="isDisabledAdvance" :label="$t('general.advanceExpense')" value="advance"></v-radio>
                    <v-radio :disabled="isDisabledRefund" :label="$t('general.refund')" value="refund"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs6 sm6 md6>
                  <v-text-field
                    v-if="type === 'advance'"
                    :disabled="editable || isPettyCash"
                    clearable
                    required
                    prepend-icon="attach_money"
                    :rules="rules.digit"
                    :persistent-hint="true"
                    :label="$t('general.advance') + $t('general.optionalField')"
                    v-model="editedItem.advance">
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialogExpense" color="primary darken-1" round flat>
            {{ $t('general.cancel') }}
          </v-btn>
          <v-btn @click="save" color="primary" round depressed :loading="loading" :disabled="loading">
            {{ $t('general.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExpenseForm" max-width="600px" persistent>
      <v-card>
        <v-toolbar flat>
          <h2 class="font-weight-black primary--text mb-0">
            {{ this.$t('expenses.edit') }}
          </h2>
        </v-toolbar>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="valid">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-menu v-model="start" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :disabled="editable"
                        clearable
                        required
                        :rules="rules.required"
                        :error-messages="errors.start_date"
                        v-model="editedItem.start_date"
                        :label="$t('general.startDate')"
                        prepend-icon="event"
                        readonly
                        v-on="on">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      color="primary"
                      :locale="$t('general.locale')"
                      v-model="editedItem.start_date"
                      :max="maxDate"
                      @input="start = false">
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-menu
                    v-model="end"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :disabled="editable"
                        clearable
                        required
                        :rules="rules.required"
                        v-model="editedItem.end_date"
                        :error-messages="errors.end_date"
                        :label="$t('general.endDate')"
                        prepend-icon="event"
                        readonly
                        v-on="on">
                      </v-text-field>
                    </template>
                    <v-date-picker
                      color="primary"
                      :locale="$t('general.locale')"
                      v-model="editedItem.end_date"
                      :min="minDate"
                      @input="end = false">
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-autocomplete
                    v-model="editedItem.project_id"
                    required
                    :rules="rules.required"
                    :error-messages="errors.project_id"
                    :label="$t('general.project')"
                    :items="projects"
                    item-value="id"
                    item-text="name">
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    :disabled="editable"
                    clearable
                    required
                    :rules="rules.required"
                    :error-messages="errors.description"
                    :label="$t('general.description')"
                    v-model="editedItem.description">
                  </v-text-field>
                </v-flex>
                <v-flex xs6 sm6 md6>
                  <v-radio-group v-model="type" row>
                    <v-radio v-if="pettyCashAmount" :disabled="isDisabledPettyCash" :label="$t('pettyCash.title')" value="pettyCash"></v-radio>
                    <v-radio v-if="amexCardAmount" :disabled="isDisabledAmexCard" :label="$t('amexCard.title')" value="amexCard"></v-radio>
                    <v-radio :disabled="isDisabledAdvance" :label="$t('general.advanceExpense')" value="advance"></v-radio>
                    <v-radio :disabled="isDisabledRefund" :label="$t('general.refund')" value="refund"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs6 sm6 md6>
                  <v-text-field
                    v-if="type === 'advance'"
                    v-model="editedItem.advance"
                    :disabled="editable || isPettyCash"
                    clearable
                    required
                    prepend-icon="attach_money"
                    :rules="rules.digit"
                    :persistent-hint="true"
                    :label="$t('general.advance') + $t('general.optionalField')">
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" round flat @click="closeDialog">
            {{ $t('general.cancel') }}
          </v-btn>
          <v-btn @click="saveExpense" color="primary" round depressed :loading="loading" :disabled="loading || editable">
            {{ $t('general.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import vue2Dropzone from 'vue2-dropzone'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faDonate } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faDonate)
export default {
  name: 'MissingExpenses',
  components: {
    vueDropzone: vue2Dropzone,
    'font-awesome-icon': FontAwesomeIcon,
  },
  data() {
    return {
      // AQUI
      tabsStatus: [
                { text: this.$t('expenses.missingExpenses.unloadedExpenses'), value: 'PENDING_APPROVAL' },
                { text: this.$t('expenses.missingExpenses.loadedWithoutVerification'), value: 'APPROVED' },
                { text: this.$t('expenses.missingExpenses.loadedWithVerification'), value: 'REJECT' },
                { text: this.$t('expenses.missingExpenses.Approved'), value: 'SENT' },
      ],
      selectedTab: 0,
      status: 'NOT_LOADED',
      confirmDiffAmountsDialog: false,
      amountItemDialog: '0',
      amountAmexDialog: '0',
      expensesAmexSelected: null,
      totalAmounts: [],
      allAmount: 0,
      consiliateAmount: 0,
      excludedAmount: 0,
      missingAmount: 0,
      employees: [],
      selectedEmployee: null,
      switchAllEmployees: true,
      selectXml: true,
      switchExpenseType: true,
      userLogged: {},
      filter_by: 'company',
      expense_type: 'amex',
      start_date: new Date().setDate(new Date().getDate() - 30),
      end_date: new Date().toISOString().substr(0, 10),
      expenses: [],
      expenses_amex_id: null,
      errorMessage: '',
      uploadedXML: [],
      uploadIndex: -1,
      loadingFile: false,
      viewImg: false,
      editedIndex: -1,
      editedIndexTip: -1,
      items: [],
      error: false,
      datemenu: false,
      dialogItem: false,
      menu: false,
      menu2: false,
      valid: true,
      loading: false,
      loadItem: false,
      loadTable: true,
      addExpenseDialog: false,
      dialog: false,
      dataURL: null,
      categories: [],
      satFormaPago: [],
      satMetodoPago: [],
      satMoneda: [],
      satPais: [],
      editedItem: {
        gst_categories: {
          name: '',
        },
        receipt_type: {
          name: '',
        },
        id: null,
        user_id: null,
        start_date: '',
        end_date: '',
        description: '',
        project_id: '',
        status: '',
        expenses_status: '',
        advance: '',
        petty_cash_type: 0,
      },
      editedItemExpense: {
        fileId: null,
        start_date: '',
        end_date: '',
        emisor: '',
        gst_expenses_id: null,
        gst_receipt_types_id: 2,
        date: null,
        gst_categories_id: null,
        categoryName: '',
        is_refund: false,
        description: '',
        exchange: 1,
        subtotal: '',
        total: '',
        country: {
          id: 151,
          descripcion: '',
        },
        currency: {
          id: 100,
          descripcion: '',
        },
        folio: '',
        comment: '',
        discount: null,
        sat_forma_pago: {
          descripcion: '',
        },
        sat_metodo_pago: {
          descripcion: '',
        },
        hasTip: false,
      },
      editedItemTip: {
        id: null,
        amount: null,
        fileId: null,
        created_at: '',
      },
      defaultItemTip: {
        id: null,
        amount: null,
        fileId: null,
        created_at: '',
      },
      defaultItem: {
        id: null,
        user_id: null,
        start_date: '',
        end_date: '',
        project_id: '',
        status: '',
        expenses_status: '',
        advance: '',
        petty_cash_type: 0,
        emisor: '',
        gst_expenses_id: null,
        gst_receipt_types_id: 2,
        date: null,
        gst_categories_id: null,
        is_refund: false,
        description: '',
        exchange: 1,
        subtotal: '',
        total: '',
        country: {
          id: 151,
          descripcion: '',
        },
        currency: {
          id: 100,
          descripcion: '',
        },
        sat_forma_pago: {
          descripcion: '',
        },
        sat_metodo_pago: {
          descripcion: '',
        },
        folio: '',
        comment: '',
        fileId: null,
        discount: null,
        hasTip: false,
        amountTip: null,
        fileIdTip: null,
      },
      cfdiHtml: null,
      errors: {},
      search: '',
      conciliations: [],
      pagination: {
        sortBy: 'id',
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
      },
      // no fiscal
      dropzoneOptions: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.default', {
          size: '5',
          unit: 'MB',
        }),
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 5,
        resizeWidth: 1080,
        resizeHeight: 1080,
        resizeMethod: 'contain',
        resizeQuality: 0.8,
        paramName: 'path',
        acceptedFiles: '.jpeg,.jpg,.png,.pdf',
        maxFiles: 1,
        headers: {
          Authorization: 'Bearer ' + this.$store.state.userState.access_token,
        },
        params: {
          user_id: this.$store.state.userLogged.id,
          dirname: 'IMG_EXPENSES',
        },
        // init: function () {
        //   const self = this
        //   this.on('success', function (file) {
        //     let parseFile = JSON.parse(file.xhr.response)
        //     self.editedItemExpense.fileId = parseFile.data.id
        //     // this.editedItemExpense.fileId = parseFile.data.id
        //   })
        // }
      },
      // fiscal
      dropzoneOptionsXML: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.textFileXml', {
          size: '500',
          unit: 'KB',
        }),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        paramName: 'path',
        dictResponseError: this.errorFileUpload,
        acceptedFiles: '.xml',
        // maxFiles: 1,
        headers: {
          Authorization: 'Bearer ' + this.$store.state.userState.access_token,
        },
        params: {
          user_id: this.$store.state.userLogged.id,
          files_type_id: 7,
          dirname: 'XML_EXPENSES',
        },
      },
      readXml: null,
      fileName: '',
      fileUrl: '',
      file: '',
      selected: [],
      dialogSelectExpenses: false,
      dialogExpenses: false,
      loadingSelectExpenses: false,
      itemsBackIds: [],
      expense: {
        id: null,
      },
      expensesOpen: [],
      paginationExpenses: {
        rowsPerPage: -1,
        sortBy: 'id',
        descending: true,
      },
      type: 'refund',
      errors: {},
      isDisabledPettyCash: false,
      isDisabledAdvance: false,
      isDisabledRefund: false,
      dialogExpenseForm: false,
      isDisabledAmexCard: false,
      editedIndex: -1,
      start: false,
      end: false,
      projects: [],
      isPettyCash: false,
      startDate: false,
      endDate: false,
      itemsBack: [],
      nextXml: false,
      errorAmount: false
    }
  },
  created() {
    this.getLogged()
  },
  computed: {
    pettyCashAmount() {
      if (!this.$store.state.userLogged.small_box) return 0;
  
      const found = this.$store.state.userLogged.small_box.find(x => x.type === 1)
      return found ? found.amount : 0
    },
    amexCardAmount() {
      if (!this.$store.state.userLogged.small_box) return 0

      const found = this.$store.state.userLogged.small_box.find(x => x.type === 2)
      return found ? found.amount : 0
    },
    projectsFilter() {
      return this.projects.filter(
        (project) => project.company_id === this.userLogged.company[0].id
      )
    },
    minDate() {
      let minDate = ''
      if (this.editedItem.start_date !== '' && this.editedItem.start_date !== null) {
        minDate = new Date(this.editedItem.start_date).toISOString().substr(0, 10)
      }
      return minDate
    },
    maxDate() {
      let maxDate = ''
      if (this.editedItem.end_date !== '' && this.editedItem.end_date !== null) {
        maxDate = new Date(this.editedItem.end_date).toISOString().substr(0, 10)
      }
      return maxDate
    },
    editable() {
      if (this.editedIndex > -1) {
        if (
          this.editedItem.created_by &&
          this.editedItem.created_by.id !== this.$store.state.userLogged.id
        ) {
          return true
        } else {
          return false
        }
      }
    },
    rules() {
      return this.$validationRules()
    },
    heading() {
      return this.$t('general.myExpenses')
    },
    subheading() {
      return ''
    },
    icon() {
      return 'fa fa-handshake fa-fw icon-color'
    },
    errorFileUpload() {
      return this.errorMessage
    },
    dataArrayFilter() {
      return this.$searchCountry()
    },
    submitXMLButton() {
      return this.uploadIndex + 1 < this.uploadedXML.length ? this.$t('general.next') : this.$t('general.charge')
    },
    setMXN() {
      let item = this.editedItem
      if (item.currency !== undefined && item.currency.id === 100) {
        item.exchange = 1
        return true
      } else {
        return false
      }
    },
    formTitle() {
      if (this.editedIndex > -1) {
        return this.$t('expenseItems.name')
      } else {
        return this.$t('general.receipt')
      }
    },
    // userLogged () {
    //   return this.$store.state.userLogged
    // },
    // sumaTotal () {
    //   let total = 0
    //   if (this.conciliations.length > 0) {
    //     this.conciliations.map(item => {
    //       let amount = this.excludedType === 'AMEX' ? item.amount : item.total_mxn
    //       amount = amount ? parseFloat(amount) : 0
    //       total = total + amount
    //     })
    //   }
    //   return total
    
    headers() {
      return [
        {
          text: '#',
          align: 'center',
          value: 'amex_expense.id',
          sortable: true,
        },
        {
          text: this.$t('conciliation.date'),
          align: 'center',
          value: 'amex_expense.date',
          sortable: true,
        },
        {
          text: this.$t('conciliation.transactionNo'),
          align: 'center',
          value: 'amex_expense.transaction_number',
          sortable: true,
        },
        {
          text: this.$t('conciliation.description'),
          align: 'center',
          value: 'amex_expense.description',
          sortable: true,
        },
        {
          text: this.$t('conciliation.user'),
          align: 'center',
          value: 'amex_expense.user.name',
          sortable: true,
        },
        {
          text: this.$t('conciliation.beneficiary'),
          align: 'center',
          value: 'amex_expense.supplier_name',
          sortable: true,
        },
        {
          text: this.$t('conciliation.amount'),
          align: 'center',
          value: 'amex_expense.amount',
          sortable: true,
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    //ELIMINAR
    headersByUser() {
      let header = this.headers
      if (this.userLogged.roles && this.userLogged.roles[0].name === 'ADMIN') {
        header = this.headers.filter(
          (x) => x.text !== this.$t('general.actions')
        )
      }
      return header
    },
    excludedExpenses() {
      let excluded = []
      if (this.expenses.length > 0) {
        excluded = this.expenses.filter((x) => x.matches.length === 0)
        excluded.forEach((item) => {
          if(item.amex_expense.expense_item_back) item.id = item.amex_expense.expense_item_back.id
        })
      }
      
      return excluded
    },
    headers2() {
      return [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: true,
        },
        {
          text: 'Rango de fecha',
          align: 'center',
          value: 'start_date',
          sortable: true,
        },
        {
          text: 'Proyecto',
          align: 'center',
          value: 'project.name',
          sortable: true,
        },
        {
          text: 'Anticipo',
          align: 'center',
          value: 'advance',
          sortable: true,
        },
      ]
    },
  },
  watch: {
    selectedTab (val) {
      // status = [NOT_LOADED, LOADED_NO_EXPENSE, LOADED_WITH_EXPENSE, LOADED_APPROVED]

        switch (val) {
            //SIN GASTOS
            case 0: 
              this.status = 'NOT_LOADED'
              this.get()  
            break
            //CON GASTO Y SIN RELACION CON COMPROBACION
            case 1: 
                this.status = 'LOADED_NO_EXPENSE' 
                this.get() 
            break
            //RELACIONADA CON COMPROBACION
            case 2: 
                this.status = 'LOADED_WITH_EXPENSE' 
                this.get() 
            break
            //APROBADA
            case 3: 
                this.status = 'LOADED_APPROVED' 
                this.get()            
            break
        }
    },
    switchExpenseType() {
      if (this.switchExpenseType === true) {
        this.selectXml = true
      } else {
        this.selectXml = false
      }
    },
    switchAllEmployees(value) {
      if (value) {
        this.selectedEmployee = null
        this.filter_by = 'company'
      } else {
        this.filter_by = 'user'
      }
    },
    '$route.params.id': function (id) {
      this.get()
    },
    '$store.state.userLogged'() {
      this.getLogged()
      this.dropzoneOptions.params.user_id = this.$store.state.userLogged.id
      this.dropzoneOptionsXML.params.user_id = this.$store.state.userLogged.id
    },
    removeDialog(val) {
      val || this.closeRemove()
    },
    search(val) {
      this.querySelection(val)
      this.dataArrayFilter.search(this.editedItemExpense.country.id, val)
    },
  },
  methods: {
    isItemSelected(item) {
      // Verifica si el objeto ya está en el arreglo de seleccionados
      return this.selected.some(selectedItem => selectedItem === item)
    },
    toggleSelection(item) {
      // Agrega o elimina el objeto de la lista de seleccionados
      const index = this.selected.findIndex(selectedItem => selectedItem === item)

      if (index === -1) {
        // Si no está seleccionado, lo añadimos
        this.selected.push(item);
      } else {
        // Si ya está seleccionado, lo removemos
        this.selected.splice(index, 1);
      }
    },
    validateTipAmount(value) {
      return this.errorAmount = (parseFloat(value) + parseFloat(this.editedItemExpense.total) + this.calculateAmountExpense(this.expensesAmexSelected.amex_expense)) > this.expensesAmexSelected.amex_expense.amount
    },
    viewAddMoreXml(data){
      return parseFloat(data.amex_expense.amount) > this.calculateAmountExpense(data.amex_expense)
    },
    validateAmount(data) {

      const originalAmount = parseFloat(data.amex_expense.amount)
      const calculatedAmount = this.calculateAmountExpense(data.amex_expense)
      const difference = Math.abs(originalAmount - calculatedAmount)

      return difference < 1;
    },
    calculateAmountExpense(data){
      return data.expense_item_back.reduce((sum, item) => {
        const total = parseFloat(item.total) || 0;
        const tipAmount = parseFloat(item.tip_amount) || 0;
        return sum + total + tipAmount;
      }, 0)
    },
    restoreExpense() {
      if(this.expense.id === null) return this.showNotification(this.$t('expenses.selectedExpense'), 'error', -1)
      this.loadingSelectExpenses = true
      
      if (this.selected.length > 0) {
        this.selected.forEach((expense) => {
          expense.amex_expense.expense_item_back.forEach((itemBack) => {
            this.itemsBackIds.push(itemBack.id)
          })
        })
      }

      this.$emit('restoreExpense', {
        gst_expenses_id: this.expense.id,
        gst_expenses_items_back_ids: this.itemsBackIds,
        context: this,
      })
    },
    save() {
      if (this.$refs.form.validate()) {
        this.postExpenseNew()
        this.loading = true
        this.disabled = true
      }
    },
    postExpenseNew() {
      this.editedItem.has_advance = this.type
      this.$emit('postExpenseNew', {
        item: this.editedItem,
        user: this.userLogged,
        context: this,
      })
    },
    closeDialogExpense() {
      this.dialogExpenses = false
      this.editedIndex = -1
      this.editedItem = Object.assign({}, this.defaultItem)
    },
    saveExpense() {
      this.errors = {}
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.editedIndex > -1) {
          this.putExpense()
        } else {
          this.postExpense()
        }
      }
    },
    postExpense() {
      this.$emit('postExpense', {
        item: this.editedItem,
        user: this.userLogged,
        context: this,
      })
    },
    putExpense() {
      this.$emit('putExpense', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this,
      })
    },
    disabledButtons(item) {
      this.isDisabledPettyCash = true
      this.isDisabledOkBlue = true
      this.isDisabledAdvance = true
      this.isDisabledRefund = true
      this.isDisabledAmexCard = true

      if (item.is_blue_voucher === 1 && item.petty_cash_type === 0) {
        this.type = 'okBlue'
        this.isDisabledOkBlue = false
        return
      } 
      
      if (item.petty_cash_type === 1) {
        this.type = 'pettyCash'
        this.isDisabledPettyCash = false
        this.isDisabledOkBlue = item.is_blue_voucher === 0
        return
      }  
      
      if (item.petty_cash_type === 2) {
        this.type = 'amexCard'
        this.isDisabledAmexCard = false
        this.isDisabledOkBlue = item.is_blue_voucher === 0
        return
      }

      if (item.advance !== '0.00') {
        this.type = 'advance'
        this.isDisabledAdvance = false
        return
      } 
      
      if (item.advance === '0.00' && item.petty_cash_type === 0 && item.is_blue_voucher === 0) {
        this.type = 'refund'
        this.isDisabledRefund = false
        return
      }
    },
    editItem(item) {
      this.disabledButtons(item)

      this.editedIndex = this.expensesOpen.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogExpenseForm = true
    },
    selectRow(item) {
      this.expense = item
      const prevItem = this.expensesOpen.find((expense) => expense.isSelected)
      if (prevItem) this.$set(prevItem, 'isSelected', false)
      this.$set(item, 'isSelected', true)
    },
    closeDialogSelectExpenses() {
      this.dialogSelectExpenses = false
      this.loadingSelectExpenses = false
      this.itemsBackIds = []
    },
    showDialogExpenses() {
      this.dialogExpenses = true
    },
    showDialogSelectExpenses() {
      if (this.selected.length > 0) {
        this.getExpensesOpen()
        this.dialogSelectExpenses = true
      }
    },
    getExpensesOpen() {
      this.$emit('getExpensesOpen', {
        context: this,
      })
    },
    showNextUpload() {
      this.errors.date = []
      this.nextXml = false
      this.readXml = null
      this.uploadIndex += 1
      if (this.uploadIndex < this.uploadedXML.length) {
        this.parseXml(this.uploadedXML[this.uploadIndex].id)
        this.getXml(this.uploadedXML[this.uploadIndex].id)
      } else {
        this.closeDialogXML()
        this.refresh()
      }
    },
    selectedEmployeeChange() {
      this.get()
      this.calculateTotals()
    },
    calculateTotals() {
      this.loading = true
      let userId = null
      if (this.userLogged.roles && this.userLogged.roles[0].name === 'ADMIN') {
        userId = this.selectedEmployee
      } else if (
        this.userLogged.roles &&
        this.userLogged.roles[0].name === 'EMPLOYEE'
      ) {
        userId = this.userLogged.id
      }
      this.$emit('calculateTotals', {
        user_id: userId,
        startDate: this.start_date,
        endDate: this.end_date,
        context: this,
      })
    },
    filterAmounts() {
      this.allAmount = this.totalAmounts.all
      this.consiliateAmount = this.totalAmounts.consiliate
      this.excludedAmount = this.totalAmounts.excluded
      this.missingAmount = this.totalAmounts.null
    },
    getLogged() {
      let current = new Date()
      let before = new Date().setDate(current.getDate() - 30)
      let dateStart = new Date(before).toISOString().substr(0, 10)
      this.start_date = dateStart
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
        this.get()
        this.getEmployees()
        this.calculateTotals()
      }
    },
    getEmployees() {
      this.companyId = this.userLogged.company[0].id
      this.$store.dispatch('expenseDetailEmployee/getCompanyEmployee', {
        event: {
          context: this,
          item: {
            companyId: this.companyId,
          },
        },
      })
    },
    addExpense(item) {
      this.expenses_amex_id = item.amex_expense.id
      this.expensesAmexSelected = item
      this.addExpenseDialog = true
    },
    querySelection(val) {
      this.items = this.dataArrayFilter.querySelection(this.satPais, val)
    },
    expenseItemsFilter() {
      this.sumaSubtotal = 0
      this.sumaDescuento = 0
      this.sumaTotal = 0
      this.filteredExpenseItems.forEach((value, index) => {
        this.sumaSubtotal +=
          value.subtotal != null ? parseFloat(value.subtotal) : parseFloat(0)
        this.sumaDescuento +=
          value.discount != null ? parseFloat(value.discount) : parseFloat(0)
        this.sumaTotal +=
          value.total != null
            ? parseFloat(value.total * value.exchange)
            : parseFloat(0)
      })
    },
    checkExpensesMessage() {
      var isNull = false
      this.filteredExpenseItems.forEach((item) => {
        if (item.subtotal == null) {
          isNull = true
        }
      })
      if (isNull) {
        return `<h5 class="mt-3"><i aria-hidden="true" class="v-icon material-icons theme--light mr-2">warning</i>${this.$t(
          'expenseItems.downloadProcess'
        )}</h5>`
      } else {
        return ``
      }
    },
    addFiscal(item) {
      this.expenses_amex_id = item.amex_expense.id
      this.dialogXML = true
    },
    addNoFiscal(item) {
      this.expenses_amex_id = item.amex_expense.id
      this.dialog = true
    },
    countryFilter(item, queryText, itemText) {
      const description = item.descripcion.toLowerCase()
      const abbr = item.c_Pais.toLowerCase()
      const searchText = queryText.toLowerCase()
      return (
        description.indexOf(searchText) > -1 || abbr.indexOf(searchText) > -1
      )
    },
    currencyFilter(item, queryText, itemText) {
      const description = item.descripcion.toLowerCase()
      const abbr = item.c_Moneda.toLowerCase()
      const searchText = queryText.toLowerCase()
      return (
        description.indexOf(searchText) > -1 || abbr.indexOf(searchText) > -1
      )
    },
    closeDialogTip() {
      this.dialogTip = false
      this.editedItemTip = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.defaultItemTip))
      )
      this.editedIndexTip = -1
      this.reset()
    },
    // Reset the current form
    reset() {
      if (this.$refs.form && this.$refs.form !== undefined) {
        this.$refs.form.resetValidation()
      }
      if (this.$refs.dropzone !== undefined) {
        this.$refs.dropzone.removeAllFiles()
      }
      this.viewImg = false
      this.dataURL = null
    },
    // showTip(item) {
    //   // let category = ''
    //   // let type = ''
    //   // if (item.gst_categories !== null) {
    //   //   category = item.gst_categories.name
    //   // }
    //   // if (item.receipt_type !== null) {
    //   //   type = item.receipt_type.name
    //   // }
    //   // if (category === 'comida' && type === 'fiscal') {
    //   //   return true
    //   // } else {
    //   //   return false
    //   // }
    // },
    // addTip(item) {
    //   this.editedItemTip.id = item.id
    //   this.getTip(item)
    //   this.dialogTip = true
    // },
    // If the form is valid, post it
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.editedItemExpense.id !== undefined) {
          this.put()
        } else {
          if (
            this.editedItemExpense.fileId !== null &&
            this.editedItemExpense.fileId !== undefined
          ) {
            this.post()
          } else {
            this.loading = false
            this.showNotification(
              this.$t('expenseItems.noFileUploaded'),
              'error',
              -1
            )
          }
        }
      }
    },
    post() {
      this.$store.dispatch('expensesItems/postFromExcluded', {
        event: {
          item: this.editedItemExpense,
          context: this,
          expense_id: null,
          expenses_amex_id: this.expenses_amex_id,
          has_next: this.uploadIndex + 1 < this.uploadedXML.length,
        },
      })
    },
    postTip() {
      if (
        this.editedItemTip.amount !== null &&
        this.editedItemTip.fileId !== null
      ) {
        this.$emit('postTip', {
          item: this.editedItemTip,
          context: this,
        })
      }
    },
    postTipExpense(expenseId) {
      if (
        this.editedItemTip.amount !== null &&
        this.editedItemTip.fileId !== null
      ) {
        this.editedItemTip.id = expenseId
        this.$emit('postTip', {
          item: this.editedItemTip,
          context: this,
        })
      }
    },
    put() {
      this.$emit('put', {
        item: this.editedItemExpense,
        index: this.editedIndex,
        context: this,
      })
    },
    submitTip() {
      if (this.$refs.tipForm.validate()) {
        this.loading = true
        if (
          this.editedItemTip.fileId !== null &&
          this.editedItemTip.fileId !== undefined
        ) {
          this.postTip()
        } else {
          this.loading = false
          this.showNotification(
            this.$t('expenseItems.noFileUploaded'),
            'error',
            -1
          )
        }
      }
    },
    closeDialog() {
      this.addExpenseDialog = false
      this.confirmDiffAmountsDialog = false
      this.editedItemExpense = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.defaultItem))
      )
      this.expenses_amex_id = null
      this.reset()
      this.dialogExpenseForm = false
    },
    closeDialogXML() {
      this.addExpenseDialog = false
      this.confirmDiffAmountsDialog = false
      this.loadingFile = false
      this.editedItemExpense = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.defaultItem))
      )
      this.uploadedXML = []
      this.uploadIndex = -1
      this.expensesAmexSelected = null
      this.resetXML()
    },
    // Reset the current form
    resetXML() {
      this.selectXml = true
      this.readXml = null
      this.errors = {}
      this.uploadedXML = []
      this.uploadIndex = -1
      this.loadingFile = false
      if (this.$refs.formXML !== undefined) {
        this.$refs.formXML.resetValidation()
      }
      if (this.$refs.dropzoneXML !== undefined) {
        this.$refs.dropzoneXML.removeAllFiles()
      }
    },
    // If the form is valid, post it
    submitXML() {
      if (this.$refs.formXML.validate()) {
        this.loading = true
        this.loadingFile = false
        this.post()
      }
    },
    xmlUpload(file, response) {
      this.loadingFile = true
      this.uploadedXML.push(response.data)
    },
    xmlQueueComplete() {
      this.selectXml = false
      this.uploadIndex = 0
      this.parseXml(this.uploadedXML[0].id)
    },
    fileAdded(file) {
      this.dropzoneOptions.params.user_id = this.$store.state.userLogged.id
      let fileType = file.type
      if (fileType === 'image/jpeg') {
        this.dropzoneOptions.params.files_type_id = 5
      } else if (fileType === 'image/png') {
        this.dropzoneOptions.params.files_type_id = 6
      } else if (fileType === 'application/pdf') {
        this.dropzoneOptions.params.files_type_id = 3
      }
    },
    fileUpload(file, response) {
      this.editedItemExpense.fileId = response.data.id
    },
    fileUploadTip(file, response) {
      this.editedItemExpense.tip_file_id = response.data.id 
      // this.editedItemTip.fileId = response.data.id
    },
    fileUploadError(file, message, xh) {
      this.showNotification(message, 'error', -1)
      this.errorMessage = message.errors.path[0]
    },
    fileAddedXml(file) {
      this.dropzoneOptionsXML.params.user_id = this.$store.state.userLogged.id
    },
    parseXml(id) {
      this.$store.dispatch('expensesItems/readXmlQueueItemFromExcluded', {
        event: {
          file_id: id,
          context: this,
        },
      })
    },
    getSatFormaPago(value) {
      return this.satFormaPago.find((element) => element.c_FormaPago === value)
    },
    getSatMetodoPago(value) {
      return this.satMetodoPago.find(
        (element) => element.c_MetodoPago === value
      )
    },
    getCurrency(value) {
      return this.satMoneda.find((element) => element.c_Moneda === value)
    },
    getCountry(value) {
      return this.satPais.find((element) => element.c_Pais === value)
    },
    // Click on file input
    pickFile() {
      this.$refs.file.click()
    },
    // Process the selected file on file input
    onFilePicked(e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.fileName = files[0].name
        if (this.fileName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.fileUrl = fr.result
          this.file = files[0] // this is an image file that can be sent to server
        })
      } else {
        this.fileName = ''
        this.file = ''
        this.fileUrl = ''
      }
    },
    amountMXN(amount, exchange) {
      if (amount === '') {
        amount = 0
      }
      return (amount * exchange).toFixed(2)
    },
    getTotal(type) {
      switch (type) {
        default:
        case 1:
          this.editedItemExpense.total = this.editedItemExpense.subtotal
          break
        case 2:
          this.editedItemExpense.subtotal = this.editedItemExpense.total
          break
      }
    },
    changeSort(header) {
      if (header.sortable) {
        if (this.pagination.sortBy === header.value) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.descending = false
        }
        this.pagination.sortBy = header.value
      } else {
        this.pagination.sortBy = ''
      }
    },
    close() {
      this.dialog = false
      this.dialogItem = false
      this.addExpenseDialog = false
      this.confirmDiffAmountsDialog = false
      this.loadTable = false
    },
    send() {
      this.get()
      this.calculateTotals()
      this.dialog = false
    },
    get() {
      this.loadTable = true
      let userId =
        this.userLogged.roles && this.userLogged.roles[0].name === 'ADMIN'
          ? null
          : this.userLogged.id
      let companyId =
        this.userLogged.roles && this.userLogged.roles[0].name !== 'ADMIN'
          ? null
          : this.userLogged.company[0].id
      let filter =
        this.userLogged.roles && this.userLogged.roles[0].name === 'ADMIN'
          ? 'company'
          : 'user'
      this.$emit('get', {
        filter_by: filter,
        company_id: companyId,
        user_id: userId,
        startDate: this.start_date,
        endDate: this.end_date,
        expense_type: this.expense_type !== '' ? this.expense_type : 'all',
        // expense_type: 'all',
        status: this.status,
        context: this,
      })
      this.$store.dispatch('getSatFormaPago', { event: { context: this } })
      this.$store.dispatch('getSatMetodoPago', { event: { context: this } })
      this.$store.dispatch('getSatMoneda', { event: { context: this } })
      this.$store.dispatch('getSatPais', { event: { context: this } })
      this.$store.dispatch('expensesItems/getCategories', {
        event: { context: this },
      })
    },
    applyFilter() {
      this.get()
      this.dialog = false
    },
    viewExpenses(item) {
      this.editedItemExpenses = item
      this.loadItem = true
      this.dialogItem = true
      this.$store.dispatch('expensesItems/getItem', {
        event: {
          id: item.id,
          context: this,
        },
      })
    },
    showExpenseItemFile() {
      if (
        this.editedItemExpense.gst_expenses_items_files !== undefined &&
        this.editedItemExpense.gst_expenses_items_files !== null
      ) {
        if (this.editedItemExpense.gst_expenses_items_files.length > 0) {
          this.$store.dispatch('getFile', {
            event: {
              context: this,
              fileId:
                this.editedItemExpense.gst_expenses_items_files[0].files_id,
            },
          })
        }
      }
    },
    isPDF(data) {
      if (data !== null) {
        let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
        if (type === 'pdf') {
          return true
        } else {
          return false
        }
      }
    },
    openPDF() {
      var tab = window.open()
      tab.document.write(
        '<body style="margin: 0;"> <iframe src="' +
          this.dataURL +
          '" frameborder="0" style="margin: 0; padding: 0; border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;"</iframe></body>'
      )
    },
    getFile(fileId) {
      this.$store.dispatch('getFile', {
        event: {
          context: this,
          fileId: fileId,
        },
      })
    },
    dateFormat(date) {
      let formatted = date.replace(/-/g, '/')
      return formatted
    },
    // Valida el modal de Agregar gasto(addExpenseDialog) en base al monto amex y el monto del user
    submitReceiptsValidate () {
      if (this.$refs.formXML && !this.$refs.formXML.validate() || this.$refs.form && !this.$refs.form.validate()) return
      const amountAmex = parseFloat(this.expensesAmexSelected.amex_expense.amount)
      const amountItem = parseFloat(this.editedItemExpense.total)
      let isDiffTo = false
      if (amountAmex !== amountItem) {
        isDiffTo = true
      }
      if (isDiffTo) {
        this.addExpenseDialog = false
        this.amountItemDialog = this.currencyFormat(amountItem)
        this.amountAmexDialog = this.currencyFormat(amountAmex)
        this.confirmDiffAmountsDialog = true
      } else {
        if (this.switchExpenseType) {
          this.submitXML()
        } else {
          this.submit()
        }
      }
    },
    currencyFormat(val) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      })
      return formatter.format(val)
    }
  }
}
</script>

<style scoped>
.rowExpense {
  cursor: pointer;
}
.selectedRow {
  background-color: #93d2f2 !important;
}
.yellow-block {
  background-color: #F8E9A1 !important;
}
.blue-block{
  background-color: #D8E8F8 !important;
}
.green-block{
  background-color: #B2E8D1 !important;
}
.red-block{
  background-color: #F4C7C3 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/missingExpenses.component.vue